import WarehouseIcon from '@mui/icons-material/Warehouse';
import DescriptionIcon from '@mui/icons-material/Description';
import PaletteIcon from '@mui/icons-material/Palette';
import BookIcon from '@mui/icons-material/Book';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import PaidIcon from '@mui/icons-material/Paid';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HomeIcon from '@mui/icons-material/Home';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { PageCategory, PageCategoryType } from '../interfaces/PageCategory';
import { PageType } from '../interfaces/AdminPage';
import { BrandPageRoot } from '../pages/Brand/BrandPageRoot';
import { BannerPageRoot } from '../pages/Banner/BannerPageRoot';
import { GalleryPageRoot } from '../pages/Gallery/GalleryPageRoot';
import { SliderPageRoot } from '../pages/Slider/SliderPageRoot';
import { BlogPageRoot } from '../pages/Blog/BlogPageRoot';
import { PagesPageRoot } from '../pages/Page/PagesPageRoot';
import { FilterPageRoot } from '../pages/ProductFilter/FilterPageRoot';
import { PopularProductsPage } from '../pages/PopularProduct/PopularProductsPage';
import { HighlightedProductsPage } from '../pages/HighlightedProduct/HighlightedProductsPage';
import { DailyPopularProductsPage } from '../pages/DailyPopularProduct/DailyPopularProductsPage';
import { CategoriesPage } from '../pages/Category/CategoriesPage';
import { FrontendSettingsPageRoot } from '../pages/FrontendSettings/FrontendSettingsPageRoot';
import { GeneralSettingsPageRoot } from '../pages/GeneralSettings/GeneralSettingsPageRoot';
import { TaxPageRoot } from '../pages/Tax/TaxPageRoot';
import { ShippingProviderPageRoot } from '../pages/ShippingProvider/ShippingProviderPageRoot';
import { TagsPageRoot } from '../pages/Tag/TagsPageRoot';
import { MenuPageRoot } from '../pages/Menu/MenuPageRoot';
import { CompanyPageRoot } from '../pages/Company/CompanyPageRoot';
import { ProductPageRoot } from '../pages/Product/ProductPageRoot';
import { ReviewPageRoot } from '../pages/Review/ReviewPageRoot';
import { OrderPageRoot } from '../pages/Order/OrderPageRoot';
import { BasketPageRoot } from '../pages/Basket/BasketPageRoot';
import { RefundPageRoot } from '../pages/Refund/RefundPageRoot';
import { UserPageRoot } from '../pages/User/UserPageRoot';
import { CouponPageRoot } from '../pages/Coupon/CouponPageRoot';
import { StockReportPage } from '../pages/StockReport/StockReportPage';
import { ExpiryReportPage } from '../pages/ExpiryReport/ExpiryReportPage';
import { SalesReportPage } from '../pages/SalesReport/SalesReportPage';
import { CustomerOrdersReportPage } from '../pages/CustomerOrdersReport/CustomerOrdersReportPage';
import { HepsiburadaOrdersPage } from '../pages/Hepsiburada/HepsiburadaOrdersPage';
import { DashboardPage } from '../pages/Dashboard/DashboardPage';
import { SlidingBannerPageRoot } from '../pages/SlidingBanner/SlidingBannerPageRoot';
import { PopupPageRoot } from '../pages/Popup/PopupPageRoot';
import { BoynerOrdersPage } from '../pages/BoynerOrders/BoynerOrdersPage';
import { OfferPageRoot } from '../pages/Offer/OfferPageRoot';
import { DiscountAtCheckoutPageRoot } from '../pages/DiscountAtCheckout/DiscountAtCheckoutPageRoot';
import { N11OrdersPage } from '../pages/N11Orders/N11OrdersPage';
import { PazaramaOrdersPage } from '../pages/PazaramaOrders/PazaramaOrdersPage';
import { SynchronizationSummaryPageRoot } from '../pages/SynchronizationSummary/SynchronizationSummaryPageRoot';
import { AffiliateUserPageRoot } from '../pages/AffiliateUser/AffiliateUserPageRoot';
import { ProductSalesReportPage } from '../pages/ProductSalesReport/ProductSalesReportPage';
import { TrendyolOrdersPageRoot } from '../pages/TrendyolOrders/TrendyolOrdersPageRoot';
import { HomepageEditorPage } from '../pages/HomepageEditor/HomepageEditorPage';
import { StockHistoryReportPage } from '../pages/StockHistoryReport/StockHistoryReportPage';
import { AiChatPage } from '../pages/AiChat/AiChatPage';

export const pageCategories: PageCategory[] = [
  {
    categoryType: PageCategoryType.MAIN_PAGE,
    name: 'Ana Sayfa',
    icon: <HomeIcon />,
    path: 'home',
    pages: [
      {
        pageType: PageType.DASHBOARD,
        name: 'Genel Bakış',
        path: 'dashboard',
        element: <DashboardPage />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.AI,
    name: 'NNET AI',
    icon: <AutoAwesomeIcon />,
    path: 'ai',
    pages: [
      {
        pageType: PageType.AI_CHAT,
        name: 'Sohbet',
        path: 'chat',
        element: <AiChatPage />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.PRODUCTS,
    name: 'Ürünler',
    icon: <WarehouseIcon />,
    path: 'products',
    pages: [
      {
        pageType: PageType.BRANDS,
        name: 'Markalar',
        path: 'brands',
        element: <BrandPageRoot />,
      },
      {
        pageType: PageType.CATEGORIES,
        name: 'Kategoriler',
        path: 'categories',
        element: <CategoriesPage />,
      },
      {
        pageType: PageType.TAXES,
        name: 'Vergiler',
        path: 'taxes',
        element: <TaxPageRoot />,
      },
      {
        pageType: PageType.CATALOG,
        name: 'Katalog',
        path: 'catalog',
        element: <ProductPageRoot />,
        disablePadding: true,
      },
      {
        pageType: PageType.PRODUCT_FILTERS,
        name: 'Filtreler',
        path: 'filters',
        element: <FilterPageRoot />,
      },
      {
        pageType: PageType.TAGS,
        name: 'Etiketler',
        path: 'tags',
        element: <TagsPageRoot />,
      },
      {
        pageType: PageType.REVIEWS,
        name: 'Değerlendirmeler',
        path: 'reviews',
        element: <ReviewPageRoot />,
      },
      {
        pageType: PageType.SYNCHRONIZATION_SUMMARY,
        name: 'Eşitleme Özeti',
        path: 'synchronization-summary',
        element: <SynchronizationSummaryPageRoot />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.SALES,
    name: 'Satışlar',
    icon: <PaidIcon />,
    path: 'sales',
    pages: [
      {
        pageType: PageType.ORDERS,
        name: 'Siparişler',
        path: 'orders',
        element: <OrderPageRoot />,
      },
      {
        pageType: PageType.BOYNER_ORDERS,
        name: 'Boyner Siparişleri',
        path: 'boyner',
        element: <BoynerOrdersPage />,
      },
      {
        pageType: PageType.TRENDYOL_ORDERS,
        name: 'Trendyol Siparişleri',
        path: 'trendyol',
        element: <TrendyolOrdersPageRoot />,
      },
      {
        pageType: PageType.HEPSIBURADA_ORDERS,
        name: 'Hepsiburada Siparişleri',
        path: 'hepsiburada',
        element: <HepsiburadaOrdersPage />,
      },
      {
        pageType: PageType.N11_ORDERS,
        name: 'N11 Siparişleri',
        path: 'n11',
        element: <N11OrdersPage />,
      },
      {
        pageType: PageType.PAZARAMA_ORDERS,
        name: 'Pazarama Siparişleri',
        path: 'pazarama',
        element: <PazaramaOrdersPage />,
      },
      {
        pageType: PageType.REFUNDS,
        name: 'İade Talepleri',
        path: 'refunds',
        element: <RefundPageRoot />,
      },
      {
        pageType: PageType.BASKETS,
        name: 'Kullanıcı Sepetleri',
        path: 'baskets',
        element: <BasketPageRoot />,
      },
      {
        pageType: PageType.COUPONS,
        name: 'Kuponlar',
        path: 'coupons',
        element: <CouponPageRoot />,
      },
      {
        pageType: PageType.OFFERS,
        name: 'Kampanyalar',
        path: 'offers',
        element: <OfferPageRoot />,
      },
      {
        pageType: PageType.DISCOUNTS_AT_CHECKOUT,
        name: 'Kasa Önü İndirimi',
        path: 'at-checkout-discount',
        element: <DiscountAtCheckoutPageRoot />,
        disablePadding: true,
      },
    ],
  },
  {
    categoryType: PageCategoryType.REPORTS,
    name: 'Raporlar',
    icon: <AssessmentIcon />,
    path: 'reports',
    pages: [
      {
        pageType: PageType.SALES_REPORT,
        name: 'Satışlar',
        path: 'sales',
        element: <SalesReportPage />,
      },
      {
        pageType: PageType.PRODUCT_SALES_REPORT,
        name: 'Ürün Satışları',
        path: 'product-sales',
        element: <ProductSalesReportPage />,
      },
      {
        pageType: PageType.CUSTOMER_ORDERS_REPORT,
        name: 'Müşteri Siparişleri',
        path: 'customer-orders',
        element: <CustomerOrdersReportPage />,
      },
      {
        pageType: PageType.STOCK_REPORT,
        name: 'Ürün Stokları',
        path: 'stock',
        element: <StockReportPage />,
      },
      {
        pageType: PageType.EXPIRY_REPORT,
        name: 'Son Kullanma Tarihleri',
        path: 'expiry',
        element: <ExpiryReportPage />,
      },
      {
        pageType: PageType.STOCK_HISTORY_REPORT,
        name: 'Stok Hareketleri',
        path: 'stock-history',
        element: <StockHistoryReportPage />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.SHIPPING,
    name: 'Kargo Firmaları',
    icon: <LocalShippingIcon />,
    path: 'shipping',
    pages: [
      {
        pageType: PageType.SHIPPING_PROVIDERS,
        name: 'Kargo Firmaları',
        path: 'providers',
        element: <ShippingProviderPageRoot />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.BLOG,
    name: 'Blog',
    icon: <BookIcon />,
    path: 'blogs',
    pages: [
      {
        pageType: PageType.BLOG,
        name: 'Blog',
        path: 'blogs',
        element: <BlogPageRoot />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.PAGES,
    name: 'Sayfalar',
    icon: <DescriptionIcon />,
    path: 'pages',
    pages: [
      {
        pageType: PageType.PAGES,
        name: 'Sayfalar',
        path: 'pages',
        element: <PagesPageRoot />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.VISUAL,
    name: 'Görünüm',
    icon: <PaletteIcon />,
    path: 'visual',
    pages: [
      {
        pageType: PageType.HOMEPAGE_EDITOR,
        name: 'Ana Sayfa Düzenleyici',
        path: 'homepage-editor',
        element: <HomepageEditorPage />,
      },
      {
        pageType: PageType.SLIDERS,
        name: 'Kaydırıcılar',
        path: 'sliders',
        element: <SliderPageRoot />,
      },
      {
        pageType: PageType.BANNERS,
        name: 'Bannerlar',
        path: 'banners',
        element: <BannerPageRoot />,
      },
      {
        pageType: PageType.SLIDING_BANNERS,
        name: 'Kayan Yazılar',
        path: 'sliding-banners',
        element: <SlidingBannerPageRoot />,
      },
      {
        pageType: PageType.POPUPS,
        name: "Pop-up'lar",
        path: 'popups',
        element: <PopupPageRoot />,
      },
      {
        pageType: PageType.GALLERIES,
        name: 'Galeri',
        path: 'galleries',
        element: <GalleryPageRoot />,
      },
      {
        pageType: PageType.FRONTEND_SETTINGS,
        name: 'Site Ayarları',
        path: 'frontend-settings',
        element: <FrontendSettingsPageRoot />,
        disablePadding: true,
      },
      {
        pageType: PageType.MENUS,
        name: 'Menüler',
        path: 'menus',
        element: <MenuPageRoot />,
      },
      {
        pageType: PageType.POPULAR_PRODUCTS,
        name: 'Popüler Ürünler',
        path: 'popular-products',
        element: <PopularProductsPage />,
      },
      {
        pageType: PageType.DAILY_POPULAR_PRODUCTS,
        name: 'Bugünün Popüler Ürünleri',
        path: 'daily-popular-products',
        element: <DailyPopularProductsPage />,
      },
      {
        pageType: PageType.HIGHLIGHTED_PRODUCTS,
        name: 'Haftanın Öne Çıkan Ürünleri',
        path: 'highlighted-products',
        element: <HighlightedProductsPage />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.USERS,
    name: 'Kullanıcılar',
    icon: <PeopleIcon />,
    path: 'users',
    pages: [
      {
        pageType: PageType.USERS,
        name: 'Kullanıcılar',
        path: 'users',
        element: <UserPageRoot />,
      },
      {
        pageType: PageType.COMPANIES,
        name: 'Bayiler / Üye Grupları',
        path: 'companies',
        element: <CompanyPageRoot />,
      },
      {
        pageType: PageType.AFFILIATE_USERS,
        name: 'Partner Kullanıcılar',
        path: 'affiliate',
        element: <AffiliateUserPageRoot />,
      },
    ],
  },
  {
    categoryType: PageCategoryType.GENERAL_SETTINGS,
    name: 'Ayarlar',
    icon: <SettingsIcon />,
    path: 'settings',
    pages: [
      {
        pageType: PageType.GENERAL_SETTINGS,
        name: 'Ayarlar',
        path: 'general-settings',
        element: <GeneralSettingsPageRoot />,
        disablePadding: true,
      },
    ],
  },
];
